export const dashboardEndpoints = {
  dashboardResponses: () => '/dashboard/responses/',
  dashboardMatches: () => '/dashboard/matches/',
  dashboardNewBids: () => '/dashboard/new-bids/',
  dashboardNewUsers: () => '/dashboard/new-users/',
  dashboardCalls: () => '/dashboard/calls/',
  dashboardCallsUS: () => '/dashboard/us-calls/',
  dashboardOverdueBids: () => '/dashboard/overdue-bids/',
  dashboardUsersWithoutBids: () => '/dashboard/users-without-bids/',
}
